<template>
  <div
    class="d-flex text-light px-sm py-xs p-md-md position-relative"
    :class="background">
    <PlainButton
      v-if="showCloseButton"
      class="position-absolute top-0 end-0 bg-transparent px-sm py-xs"
      @click="emit('close')">
      <SvgX
        color="white"
        width="16"
        height="16"/>
    </PlainButton>
    <div
      class="d-flex flex-column align-items-center w-100 gap-xs"
      :class="{'justify-content-between' : !noLineBreak, 'justify-content-center' : noLineBreak, 'flex-md-row': !centerText }">
      <div class="d-flex align-items-center gap-md">
        <div v-if="showIcon">
          <slot name="icon">
            <SvgDiscover
              :width="iconSize"
              :height="iconSize"/>
          </slot>
        </div>
        <p :class="{'d-flex align-items-center' : !hasTitleSlot, 'd-flex text-center' : noLineBreak, 'flex-column text-center' : centerText }">
          <b v-if="hasTitleSlot">
            <slot name="title"/>
            <br v-if="!noLineBreak">
          </b>
          <span :class="{'ps-xxs' : noLineBreak || !isTabletOrSmaller && !hasTitleSlot }">
            <slot name="text"/>
          </span>
        </p>
      </div>
      <div
        v-if="button || link"
        class="d-flex align-items-center justify-content-center"
        :class="{ 'w-100' : isMobile }">
        <BaseButton
          v-if="button"
          :class="button.classes"
          :text="button.text"
          :variant="button.variant"
          @click="button.action"/>
        <BaseLink
          v-if="link"
          :to="link.to"
          :text="link.title"
          class="text-link"
          :class="link.classes"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, useSlots } from 'vue'
import useScreenSize from '@shared/composables/screenSize.js'
import BaseLink from '@shared/components/BaseLink.vue'
import SvgDiscover from '@/components/global/svg/SvgDiscover.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import PlainButton from '@/components/global/sequin/PlainButton.vue'
import SvgX from '@shared/components/icons/SvgX.vue'

const props = defineProps({
  link: {
    type: Object,
    default: null
  },
  type: {
    type: String,
    default: 'default',
    validator: value => {
      return ['default', 'default-center', 'no-line-break-primary', 'no-line-break-secondary', 'smart', 'router-link'].includes(value)
    }
  },
  button: {
    type: Object,
    default: null
  },
  showIcon: {
    type: Boolean,
    default: true
  },
  showCloseButton: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close'])

const { isMobile, isTabletOrSmaller } = useScreenSize()
const slots = useSlots()

const iconSize = computed(() => isTabletOrSmaller.value ? 25 : 35)
const hasTitleSlot = computed(() => !!slots.title && !!slots.title()[0].children)
const noLineBreak = computed(() => props.type.includes('no-line-break'))
const background = computed(() => {
  return {
    'bg-teal': props.type === 'smart',
    'bg-primary': props.type.includes('default') || props.type.includes('primary'),
    'bg-secondary': props.type.includes('secondary')
  }
})
const centerText = computed(() => isMobile.value || props.type.includes('center'))
</script>

<style scoped lang="scss">
:deep(.base-link) {
  color: inherit !important;
}
</style>
